// this is the override for auth call

module.exports = {
  request: function (req, token) {
    // if (req.url.indexOf('auth/refresh') !== -1) {
    //   req.data = { refresh: localStorage.getItem('refresh') };
    // }
    this.options.http.setHeaders.call(this, req, {
      Authorization: 'Bearer' + token
    })
  },
  response: function (res) {
    // if (res.data.refresh) {
    //   localStorage.setItem('refresh', res.data.refresh);
    // }
    return (res.data || {}).access
  }
}
